const Home = '/'

// const ComboPackage = '/combopackage'
// const Sandwiches = '/sandwiches'
// const Lunchboxes = '/lunchboxes'
// const Drinks = '/drinks'
// const Cookies = '/cookies'

const CartDetail = '/cart'
const Checkout = '/checkout'
const Register = '/register'
const ForgotPassword = '/forgot-password'
const GiantSub = '/giantsub'
const CheckoutSuccess = '/thankyou'
const OurLocation = '/location'
const ContactUs = '/contact-us'
const FAQ = '/faq'
const UserTerm = '/terms'
const PrivacyPolicy = '/privacy-policy'
// profile
const MyOrders = '/orders'
const MyOrderDetail = '/order-detail'
const MyCredit = '/credit'
const MyInformation = '/myinfo'

export default {
  Home,
  // ComboPackage,
  // Sandwiches,
  // Lunchboxes,
  // Drinks,
  // Cookies,
  CartDetail,
  Checkout,
  Register,
  ForgotPassword,
  GiantSub,
  CheckoutSuccess,
  OurLocation,
  ContactUs,
  FAQ,
  UserTerm,
  PrivacyPolicy,
  // profile
  MyOrders,
  MyOrderDetail,
  MyCredit,
  MyInformation
}



// WEBPACK FOOTER //
// ./src/router/config.js